var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dyrs-font-icon-button",style:({
    border: _vm.border
      ? _vm.disabled
        ? '1px solid ' + _vm.predefinedColorMap['disable']
        : !_vm.isHover
        ? '1px solid ' + _vm.hoverBackgroundColor
        : '1px solid transparent'
      : '1px solid transparent',
    background:
      !_vm.disabled && _vm.isHover
        ? _vm.hoverBackgroundColor
        : _vm.normalStateBackGroundColor,
    'border-radius': _vm.weight / 2 + 'px',
    width: _vm.weight + 'px',
    height: _vm.weight + 'px',
    'line-height': _vm.weight - 2 + 'px',
    cursor: _vm.disabled ? 'not-allowed' : '',
  }),attrs:{"type":_vm.type},on:{"click":function($event){return _vm.handleClick($event)},"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}},[(_vm.elementIcon)?_c('i',{class:_vm.icon,style:({
      color: _vm.disabled
        ? _vm.predefinedColorMap['disable-color']
        : _vm.isHover
        ? 'white'
        : _vm.hoverBackgroundColor,
    })}):_c('font-awesome-icon',{style:({
      'margin-left': _vm.weight / 4 - 1 + 'px',
      'margin-top': _vm.weight / 4 - 1 + 'px',
      width: _vm.weight / 2 + 'px',
      height: _vm.weight / 2 + 'px',
      color: _vm.disabled
        ? _vm.predefinedColorMap['disable-color']
        : _vm.isHover
        ? 'white'
        : _vm.hoverBackgroundColor,
    }),attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }